import "./node_modules/bootstrap/dist/css/bootstrap.css";
import "./src/styles/Font.css";
import "./src/styles/Global.css";


